import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-24 border-t border-[#EAE4D8] bg-ivory" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        {/* Logo block */}
        <div>
          <Link to="/" className="inline-block">
            <span className="font-serif text-[26px] lg:text-[30px] tracking-[0.18em] text-black font-medium">MSK WATCH</span>
          </Link>
        </div>

        <div>
          <h4 className="text-xs tracking-luxury uppercase mb-4 text-black">{t('footer.boutique')}</h4>
          <ul className="space-y-2 text-sm text-[#555]">
            <li><Link to="/collections" className="hover:text-black">{t('footer.nosCollections')}</Link></li>
            <li><Link to="/montres" className="hover:text-black">{t('footer.tousLesModeles')}</Link></li>
            <li><Link to="/panier" className="hover:text-black">{t('footer.panier')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-luxury uppercase mb-4 text-black">{t('footer.support')}</h4>
          <ul className="space-y-2 text-sm text-[#555]">
            <li><Link to="/faq" className="hover:text-black">{t('footer.faq')}</Link></li>
            <li><Link to="/suivi" className="hover:text-black">{t('footer.suivi')}</Link></li>
            <li><Link to="/contact" className="hover:text-black" data-testid="footer-contact-link">{t('footer.contact')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-luxury uppercase mb-4 text-black">{t('footer.legal')}</h4>
          <ul className="space-y-2 text-sm text-[#555]">
            <li><Link to="/legal/mentions-legales" className="hover:text-black" data-testid="footer-legal-mentions-link">{t('footer.mentionsLegales')}</Link></li>
            <li><Link to="/legal/confidentialite" className="hover:text-black" data-testid="footer-legal-confidentialite-link">{t('footer.confidentialite')}</Link></li>
            <li><Link to="/legal/remboursement" className="hover:text-black" data-testid="footer-legal-remboursement-link">{t('footer.remboursement')}</Link></li>
            <li><Link to="/legal/cgv" className="hover:text-black" data-testid="footer-legal-cgv-link">{t('footer.cgv')}</Link></li>
            <li><Link to="/legal/livraison" className="hover:text-black" data-testid="footer-legal-livraison-link">{t('footer.livraison')}</Link></li>
            <li><Link to="/legal/retours" className="hover:text-black" data-testid="footer-legal-retours-link">{t('footer.retours')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-luxury uppercase mb-4 text-black">{t('footer.contactHeading')}</h4>
          <div className="flex gap-3 items-center text-[#555]">
            <a href="mailto:mskwatchh@gmail.com" className="hover:text-black" aria-label="Email" data-testid="footer-email-link"><Mail className="w-5 h-5" strokeWidth={1.2} /></a>
            <a href="https://instagram.com/msk.watchs" target="_blank" rel="noopener noreferrer" className="hover:text-black" aria-label="Instagram" data-testid="footer-instagram-link"><Instagram className="w-5 h-5" strokeWidth={1.2} /></a>
            <a href="https://www.tiktok.com/@msk.watch" target="_blank" rel="noopener noreferrer" className="hover:text-black" aria-label="TikTok" data-testid="footer-tiktok-link"><TikTokIcon className="w-5 h-5" /></a>
          </div>
          <p className="text-xs text-[#777] mt-4">mskwatchh@gmail.com</p>
        </div>
      </div>

      <div className="border-t border-[#EAE4D8] py-6 text-center text-[11px] tracking-luxury uppercase text-[#888]">
        © {new Date().getFullYear()} MSK WATCH — {t('footer.copyright')}
      </div>
    </footer>
  );
}
